import { Box, Typography } from "@material-ui/core";
import React ,{useEffect} from "react";
import I18n from "../../../localization";
import { Header } from "../../../components/Header";
import { useMobileStyles } from "./styles.js";
import Icon from "../../../utils/icons";
import { APP_SOURCE, PAGES } from "../../../utils/constant.js";
import {getIQAirSystem, isWeb} from "../../../utils/utility"
import { setGlobalState,getGlobalState } from "../../../utils/globalState";

export default function IQAirAndHVACSetting(props) {
  const classes = useMobileStyles();
  
  const airSystemObj = getIQAirSystem()
  const airSystem = airSystemObj.find(airSys=>props.airDeviceId === airSys['device-id'])
  const airDevices = airSystem && airSystem['air-devices']
  const airDeviceName = getGlobalState('airDeviceName')

  useEffect(()=>{
    if(props.airDeviceName && isWeb() && props.updateHeaderText){
      props.updateHeaderText(props.airDeviceName)
    }
  
  },[props.airDeviceName])


  function airDevicesLabels(){
  return airDevices.map(device =>{
    return {
      title: device.name,
      subTitle: I18n.t('mobile.iqAirSetting.iqAirSubtitle'),
      onClick: () => {
        setGlobalState("iqAirId", device['device-id'])
        props.handleClick(PAGES.IQ_AIR_SETTING, null, device.name)
      },
    }
   })
  }

  const settingsRenderItems = [
    {
      subHeading: I18n.t('mobile.iqAirSetting.hvacSettingsTitle'),
      cards: [
        // {
        //   title: I18n.t('mobile.iqAirSetting.energyModeTitle'),
        //   subTitle: I18n.t('mobile.iqAirSetting.energyModeSubTitle'),
        //   onClick: () => {
        //     props.handleClick(PAGES.HVAC_ENERGY_MODE)
        //   },
        // },
        {
          title: I18n.t('mobile.iqAirSetting.hvacDetailsTitle'),
          subTitle: I18n.t('mobile.iqAirSetting.hvacDetailsSubTitle'),
          onClick: () => {
            props.handleClick(PAGES.HVAC_DETAILS)
          }, 
        },
      ],
    },
    {
      subHeading: I18n.t('mobile.iqAirSetting.thermostatSettingsTitle'),
      cards: [...airDevicesLabels()],
    },
  ];

  return (
    <>
      <div className={classes.IQAirContainer}>
        { !props.isWeb &&
          <Header title={airDeviceName} onClick={() => props.handleClick(props.onGoBack, PAGES.AIR_SYSTEM_SETTING)} />
        }

        {settingsRenderItems.map((v) => {
          return (
            <>
              <Box className={classes.ChargerSettingContainer}>
                <Typography className={classes.subHeading}>
                  {v.subHeading}
                </Typography>
                <Box className={classes.settingsCardWrapper}>
                {v.cards.map((t) => {
                  return (
                    <Box className={classes.settingsCard}>
                      <Box
                        className={classes.ChargerSettingHeading}
                        onClick={() => t.onClick()}
                      >
                        <Typography className={classes.SettingHeading}>
                          {t.title}
                        </Typography>
                        <Typography className={classes.SettingBaseLine}>
                          {t.subTitle}
                        </Typography>
                        <Box className={props.source === APP_SOURCE.ENL ? classes.ENLChargingSettingForwardIcon : classes.ChargingSettingForwardIcon}>
                          <Icon src="forwardArrow" />
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
                </Box>
              </Box>
            </>
          );
        })}
      </div>
    </>
  );
}
